import {
    FETCH_ACCOUNT_YIELDS,
    FETCH_ACCOUNT_YIELDS_FAILURE,
    FETCH_ACCOUNT_YIELDS_SUCCESS,

    FETCH_ACCOUNT_YIELD,
    FETCH_ACCOUNT_YIELD_FAILURE,
    FETCH_ACCOUNT_YIELD_SUCCESS,
} from 'store/actions/types';
import utils from 'helpers/utils';
import accountYieldsHelper from 'helpers/accountYields';

export const fetchAccountYields = (payload) => {
    payload = payload || {};

    let params = {
        size: payload.size ? payload.size : 12,
        sort_by: payload.field ? payload.field : 'account_name',
        sort_direction: payload.order ? payload.order.toLowerCase() : 'asc',
    };

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = Object.assign({}, params, filters);
    }

    return {
        type: FETCH_ACCOUNT_YIELDS,
        payload: params,
    };
};

export const fetchAccountYieldsFailure = (error) => {
    return {
        type: FETCH_ACCOUNT_YIELDS_FAILURE,
        error: error,
    };
};

export const fetchAccountYieldsSuccess = (payload) => {
    const normalizedValues = Object.assign({}, payload);
    const { results } = normalizedValues;

    results.forEach((result) => {
        accountYieldsHelper.formatToFactor(result, 'yield');
    });

    return {
        type: FETCH_ACCOUNT_YIELDS_SUCCESS,
        payload: normalizedValues,
    };
};

export const fetchAccountYield = (payload) => {
    return {
        type: FETCH_ACCOUNT_YIELD,
        payload: payload,
    };
};

export const fetchAccountYieldFailure = (error) => {
    return {
        type: FETCH_ACCOUNT_YIELD_FAILURE,
        error: error,
    };
};

export const fetchAccountYieldSuccess = (response) => {
    const normalizedValues = Object.assign({}, accountYieldsHelper.formatToFactor(response, 'yield'));

    return {
        type: FETCH_ACCOUNT_YIELD_SUCCESS,
        response: normalizedValues,
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/account-yields/fetchAccountYields.js